<template>
  <section class="section section-white content-padded" onload="init()">
    <el-form ref="form" :model="form" label-width="130px">
      <el-form-item label="营业时间">
        <el-time-select placeholder="起始时间" v-model="startTime"
                        :picker-options="{ start: '00:00', step: '00:01', end: '24:00' }"></el-time-select>
        <el-time-select placeholder="结束时间" v-model="endTime"
                        :picker-options="{start: '00:00', step: '00:01', end: '24:00' , minTime: startTime }"></el-time-select>
        <p class="frm-tips">24小时制，如10：00-20：30</p>
      </el-form-item>
      <el-form-item label="店铺英克ID" >
        <el-input type="textarea" style="width: 30%;" v-model="form.distributor_ids" placeholder="请输入店铺英克ID，多个ID使用换行分割" :rows="15"></el-input>
      </el-form-item>
      <div class="section-footer with-border content-center">
        <el-button type="primary" @click="updateStoreOperatingTime" :loading="submitLoading">{{submitLoading ? '提交中' : '保存'}}</el-button>
      </div>
    </el-form>
  </section>
</template>
<script>
  import { mapGetters } from 'vuex'
  import { updateOperatingTime } from '@/api/marketing'
  export default {
    data () {
      return {
        startTime: '08:00',
        endTime: '21:00',
        submitLoading: false,
        form: {
          distributor_ids: '',
        },
      }
    },
    computed: {
      ...mapGetters([
        'wheight'
      ])
    },
    methods: {
      updateStoreOperatingTime() {
        this.submitLoading = true
        this.form.hour = this.startTime + '-' + this.endTime
        console.log(this.form);
        updateOperatingTime(this.form).then(res => {
          console.log(res.data)
          this.submitLoading = false
          this.$message({type: 'success', message: '店铺营业时间更新成功'})
        }).catch(error => {
          this.submitLoading = false
        })
      },
    },
  }
</script>
<style scoped lang="scss">
  .el-row {
    margin-bottom: 20px;
    &:last-child {
      margin-bottom: 0;
    }
    img {
      width: 90%;
    }
  }
  .el-col {
    border-radius: 4px;
  }
  .bg-purple-dark {
    background: #99a9bf;
  }
  .bg-purple {
    background: #d3dce6;
  }
  .bg-purple-light {
    background: #e5e9f2;
  }
  .grid-content {
    border-radius: 4px;
    min-height: 10px;
    img {
      width: 90%;
    }
  }
  .row-bg {
    padding: 10px 20px;
    background-color: #f9fafc;
  }
  .service-label .el-checkbox:first-child{
    margin-left: 15px;
  }
  .service-label .el-input:first-child{
    margin-left: 15px;
  }
  .grid-detail {
    max-height: 300px;
    overflow-y: scroll;
    margin-bottom: 20px;
  }
  .el-carousel {
    width: 375px;
  }
</style>
<style lang="scss">
  .grid-detail {
    table, .detail-content-wrap, .detail-content-item {
      width: 100%!important;
    }
    img {
      width: 100%;
    }
  }
  .grid-attribute {
    table {
      width: 100%!important;
    }
  }
</style>



// WEBPACK FOOTER //
// operating_time.vue?3bfc4fb6